var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyElementBase, ReactElementFactory, SurveyActionBar } from "survey-react-ui";
var SideBarDefaultHeader = /** @class */ (function (_super) {
    __extends(SideBarDefaultHeader, _super);
    function SideBarDefaultHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SideBarDefaultHeader.prototype, "model", {
        get: function () {
            return this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    SideBarDefaultHeader.prototype.getStateElement = function () {
        return this.model;
    };
    SideBarDefaultHeader.prototype.renderElement = function () {
        var title = !!this.model.title ? (React.createElement("div", { className: "svc-side-bar__container-title" }, this.model.title)) : null;
        return (React.createElement("div", { className: "svc-side-bar__container-header" },
            React.createElement("div", { className: "svc-side-bar__container-actions" },
                React.createElement(SurveyActionBar, { model: this.model.toolbar })),
            title));
    };
    return SideBarDefaultHeader;
}(SurveyElementBase));
export { SideBarDefaultHeader };
ReactElementFactory.Instance.registerElement("svc-side-bar-default-header", function (props) {
    return React.createElement(SideBarDefaultHeader, props);
});
